import React from "react";
import { Nav } from "../../../../layouts/navbar/nav";
import images from "../../../../constant/images";
import {
  PiFacebookLogoLight,
  PiGoogleLogo,
  PiTwitterLogo,
} from "react-icons/pi";
import Header from "../../../../layouts/header";

export const Host = () => {
  return (
    <>
      <div className="flex flex-col gap-[2rem]  mb-[5rem]">
        {/* <div
          style={{
            backgroundImage: `url(${images.Industry})`,
            height: "60vh",
            backgroundPosition: "40%",
            backgroundRepeat: "no-repeat",
            marginBottom: "0/5rem",
            backgroundSize: "cover",
            position: "relative",
          }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-25"></div>
          <div>
            <Nav />
          </div>
          <div className="h-[50%] flex items-center justify-center">
            <h1 className="text-center relative text-white text-6xl mt-[3.5rem] custom-font">
              Non classé
            </h1>
          </div>
          <svg
            className="absolute bottom-[-9%] left-0 "
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1440 320"
          >
            <path
              class="white"
              fill="#fff"
              fill-opacity="1"
              d="M0,224L60,213.3C120,203,240,181,360,186.7C480,192,600,224,720,245.3C840,267,960,277,1080,250.7C1200,224,1300,170,1380,140L1440,120L1440,320L1380,320C1300,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"
            ></path>
          </svg>
        </div> */}
        <Header image={images.Industry} title={"GTM GOLF BLOG"} />
      </div>

      <div className="px-4 sm:px-8 md:px-12 lg:ps-[12rem] lg:pe-[8rem] mb-[8rem]">
        <div className="flex flex-col md:flex-row gap-3">
          <div className="flex flex-col gap-2">
            <p className="flex flex-col ps-[13px] pe-[13px] pt-[5px] pb-[5px] items-center bg-[#45ac4d] text-white font-bold text-[20px]">
              16 <span className="text-[14px] font-[500]">sep</span>
            </p>
            <div>
              <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#4c67a2] border-2">
                <PiFacebookLogoLight />
              </div>
              <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#00acee] border-2">
                <PiTwitterLogo />
              </div>
              <div className="ps-[13px] pe-[13px] pt-[15px] pb-[15px] text-3xl text-[#d77066] border-2">
                <PiGoogleLogo />
              </div>
            </div>
          </div>

          <div className="flex flex-col gap-[2rem]">
            <p className="  text-2xl sm:text-3xl md:text-4xl custom-font ">
              Morocco to host WATC in 2027
            </p>
            <p className="text-[#888686] text-[19px] font-[500] w-full md:w-[75vw]">
              Rabat, Wednesday, August 31, 2022 – Under the presidency of His
              Royal Highness Prince Moulay Rachid, the Royal Moroccan Golf
              Federation (FRMG) will organize the “World Amateur Team
              Championships” (WATC) in 2027, at the Royal Golf Dar Es Salam in
              Rabat.
              <br />
              <br />
              Organized every two years by the International Golf Federation
              (IGF), this prestigious World Amateur Team Championship includes
              two events – the Espirito Santo Trophy (women) and the Eisenhower
              Trophy (men). Organized for the first time in 1958, the WATC
              brings together up to 72 countries that compete over four days of
              play.
              <br />
              <br />
              At this biennial meeting of the IGF were held the elections to
              designate the two host countries of the next editions, after which
              Singapore (2025) and Morocco (Rabat in 2027) were appointed to
              succeed France (Paris currently) and the United Arab Emirates
              (Dubai in 2023).
              <br />
              <br />
              Mr. Antony Scanlon, Executive Director of the IGF, said, “The IGF
              is fortunate to have received outstanding nominations to host the
              Amateur World Championships. We are convinced that the Royal
              Moroccan Golf Federation will be an exceptional host for the best
              amateur players in the world, that our athletes will be warmly
              welcomed and will have a fantastic experience in Morocco” Morocco
              will be the first North African nation to host this prestigious
              competition which saw the participation of very big names in this
              sport such as Nick Price (winner of the Hassan II Trophy 1995),
              Tiger Woods or Jack Nicklaus to name a few. Hosting this event
              will be an opportunity to promote the practice of golf and gauge
              the level of our elite players through the organization and
              management of this reference competition.
              <br />
              <br />
              “Chaired by His Royal Highness Prince Moulay Rachid, the FRMG is
              pleased to host the World Amateur Championships in 2027,” said
              Jalil Benazzouz, President of the Sports Commission of the Royal
              Moroccan Golf Federation. “These championships are flagship events
              in the world of golf, to which Morocco has attached great value
              for more than 50 years. Hosting WATC 2027 in Morocco is an
              important element of our strategy to promote national golf on a
              large scale, to significantly increase the number of licensees,
              especially among women and young people, and make Morocco known as
              a quality golf destination. We look forward to receiving all the
              players”.
              <br />
              <br />
              The Royal Moroccan Golf Federation will host both events on the
              courses of the Royal Golf Dar Es Salam recognized worldwide for
              hosting large-scale international events including the Hassan II
              Golf Trophy and the Lalla Meryem Cup.
              <br />
              <br />
              Highly appreciated, the application of the FRMG has benefited from
              the support of the Ministry of Education of Preschool and Sports
              and the Moroccan National Olympic Committee. <br />
              It should be noted that in parallel, the 2022 edition is running
              its course and the National Women’s Team did not disappoint by
              signing a 38th place during the Espirito Santo Trophy won by
              Sweden.
              <br />
              <br />
              On the gentlemen’s side, 71 nations will take part in the 32nd
              edition of the Einsenhower Trophy during which Denmark will defend
              its title. Our representatives Mohamed Nizar Bourehim, recent
              winner of the Granx prix des Aisses (in France), El Mehdi Fakori
              and Hugo Mazen Trommetter, respectively champion and vice-champion
              of Morocco Elite 2021, will be keen to carry the national flag
              high during this prestigious tournament.
            </p>
          </div>
        </div>
      </div>

      {/* <div className="flex flex-col ps-[7rem] mb-[8rem]">
        <h1 className="text-2xl  custom-font">Leave A Reply</h1>
        <p className="text-[#7c7c7c] text-[19px] font-[500] ">
          Vous devez <span className="text-[#45ac4d]">vous connecter</span> pour
          publier un commentaire.
        </p>
      </div> */}
    </>
  );
};
